import React from 'react'

import Navbar from './Navbar'
import Sidebar from './Sidebar'

function NewDashboard() {
  return (
    <div>
      <Sidebar/>
      <Navbar/>
    </div>
  )
}

export default NewDashboard
